import { SVGProps } from 'react';

const TrendingUp = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M22 13V7h-6m6 0-8.5 8.5-5-5L2 17"
    />
  </svg>
);
export default TrendingUp;
